import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './config';

export interface LoadingState {
  isLoading: boolean;
  message?: string | undefined;
}

const initialState: LoadingState = {
  isLoading: false,
  message: undefined,
};

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    open: (state, action: PayloadAction<string | undefined>) => {
      state.isLoading = true;
      state.message = action.payload;
    },

    close: (state) => {
      state.isLoading = false;
      state.message = undefined;
    },
  },
});

export const selectLoading = (state: RootState) => state.loading;

export const { open, close } = loadingSlice.actions;
export default loadingSlice.reducer;
